module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-page-transition u-fixed u-pos-tl u-zindex--9 u-fit u-bg--white",
    class: [_vm.isActive ? 'is-visible' : 'is-hidden']
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a35330ea"}!./src/scripts/components/app-page-transition/template.html
// module id = 201
// module chunks = 0